import angular from 'angular'
import uiRouter from 'angular-ui-router'

import component from './catalog-content.component'

let module = angular.module('catalog.content', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('vehicle.catalog.maps', {
      url: '/maps/:category',
      component: 'catalogContent',
      params: {
        category: 'maps'
      },
      authenticate: true
    })
  $stateProvider
    .state('vehicle.catalog.appsAndServices', {
      url: '/app-and-services/:category',
      component: 'catalogContent',
      params: {
        category: 'essentials'
      },
      authenticate: true
    })
})

.component('catalogContent', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/catalog-content/index.js